import type { AsyncConfirmationModalActions, AsyncConfirmationModalState } from "./types";

export const initialState: AsyncConfirmationModalState = {
  isOpen: false,
  stack: [],
};

export const reducer = (
  state: AsyncConfirmationModalState,
  action: AsyncConfirmationModalActions
): AsyncConfirmationModalState => {
  switch (action.type) {
    case "OPEN_MODAL":
      return {
        ...state,
        stack: [...state.stack, action.modal],
        isOpen: action.openOnAdd ? true : state.isOpen,
      };
    case "CLOSE_MODAL":
      return {
        ...state,
        stack: state.stack.slice(0, state.stack.length - 1),
        isOpen: state.stack.length === 1 ? false : state.isOpen,
      };
    default:
      return state;
  }
};
